export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14256.59e5b192.jpg";